"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { GmailConnectButton } from "@/components/email/gmail-connect-button";
import { useGmailAuth } from "@/hooks/use-gmail-auth";
import { Button } from "@/components/ui/button";
import { useAction } from "convex/react";
import { api } from "@convex/_generated/api";
import { useState } from "react";
import { RefreshCw, Loader2 } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

export function EmailSection() {
  const { connection } = useGmailAuth();
  const triggerSync = useAction(api.email.sync.triggerSync);
  const [syncing, setSyncing] = useState(false);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const result = await triggerSync();
      console.log("Sync result:", result);
    } catch (error) {
      console.error("Sync failed:", error);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Email</CardTitle>
        <CardDescription>
          Connect Gmail to send and receive support emails in-app
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <GmailConnectButton />

        {connection && (
          <div className="space-y-3 pt-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Last synced</span>
              <span>
                {connection.lastSyncAt
                  ? formatDistanceToNow(connection.lastSyncAt, { addSuffix: true })
                  : "Never"}
              </span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={handleSync}
              disabled={syncing}
              className="w-full"
            >
              {syncing ? (
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              ) : (
                <RefreshCw className="h-4 w-4 mr-2" />
              )}
              Sync Now
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
